import Card from '@/components/card/card-component';
import { Col, Row } from '@/components/grid/grid-component';
import { Heading2Text } from '@/utils/global-fonts';
import { BsPersonCircle } from 'react-icons/bs';
import {
  MdAssignmentInd,
  MdListAlt,
  MdPersonAdd,
  MdSpaceDashboard,
} from 'react-icons/md';
import styled from 'styled-components';

const StyledMainRow = styled.div`
  padding: 40px;
  margin: 0 0 40px 0;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.COLOR_BLACK} !important;
  justify-content: space-around;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

const StyledGridCol = styled.div`
  display: flex;
  align-items: center;

  &:first-child {
    flex-direction: column;
    min-width: 350px;
    align-items: flex-start;
    padding: 0 0 0 32px;
  }

  &:nth-child(2) {
    width: fit-content;
    column-gap: 2em;
    row-gap: 2em;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
`;

const StyledCol = styled.div``;

const StyledSecondRow = styled.div`
  width: 100%;
  gap: 12px;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const StyledTileRow = styled(Row)`
  margin: 0 !important;
  height: 130px;

  a {
    text-decoration: none;
    font-weight: 600;
  }
`;

const StyledInnerTileRow = styled(Row)`
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0 !important;

  a {
    span {
      color: ${(props) => props.theme.COLOR_TEXT};
    }
    text-decoration: none;
  }
`;

const StyledSecondTileRow = styled(Row)`
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  height: 130px;
`;

const StyledTile = styled(Card)`
  height: 161px;
  width: 180px;
  border-radius: 6px;
  cursor: pointer;
`;

const StyledSecondRowTile = styled(Card)`
  width: 100%;
  border-radius: 6px;
  cursor: pointer;
`;

const StyledSecondRowCol = styled(Col)`
  padding: 0 !important;
  margin: 0;
  box-shadow: 0px 3px 10px 0px #0000001a;
`;

const StyledIconDiv = styled.div`
  display: flex;
  height: 100px;
  width: 100px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.COLOR_GREY5};
`;

const CompanyIcon = styled(MdAssignmentInd)`
  margin-bottom: 10px;
`;
const UserIcon = styled(MdPersonAdd)`
  margin-bottom: 10px;
`;
const CategoryIcon = styled(MdSpaceDashboard)`
  margin-bottom: 10px;
`;
const PricelistIcon = styled(MdListAlt)`
  margin-bottom: 10px;
`;

const PersonIcon = styled(BsPersonCircle)`
  margin-right: 10px;
`;

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
`;

const StyledHeading2Text = styled(Heading2Text)`
  margin-bottom: 16px;
`;

const Hero = styled.img`
  width: 56px;
  height: 56px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 30px;
`;

const styledDashboard = {
  StyledMainRow,
  StyledTileRow,
  UserIcon,
  PersonIcon,
  CategoryIcon,
  PricelistIcon,
  StyledSecondTileRow,
  StyledInnerTileRow,
  StyledIconDiv,
  StyledTile,
  Hero,
  StyledDiv,
  CompanyIcon,
  StyledHeading2Text,
  StyledSecondRowCol,
  StyledSecondRow,
  StyledSecondRowTile,
  StyledCol,
  Container,
  StyledGridCol,
};

export default styledDashboard;
